import apiUrls from '../urls'
import { apiRole } from '../apiRole'

export default function (api) {
	return {
		getGifts(ctx) {
			return api.get(`${apiUrls.GIFTS}?page=${ctx.current_page}`)
		},
		activateGift(id) {
			return api.post(
				apiRole.isDedicatedDistributor
					? apiUrls.DIST_ACTIVATE_GIFT
					: apiUrls.ACTIVATE_GIFT,
				{ order_id: id }
			)
		},
	}
}
